import { Eye, Loader2 } from "lucide-react";
import { trpc } from "@/lib/trpc";
import { PAGINA_ENCERRADA, sairDoVerComo } from "@/lib/ver-como";

/** Faixa do "ver como": deixa claro de quem é a conta, que é só leitura e até quando vale. */
export function FaixaVerComo({ nome, expiraEm }: { nome: string; expiraEm: Date | string }) {
  const encerrar = trpc.verComo.encerrar.useMutation({
    onSettled: () => {
      sairDoVerComo();
      window.location.replace(PAGINA_ENCERRADA);
    },
  });
  const ate = new Date(expiraEm).toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
  return (
    <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 bg-amber-500 px-4 py-1.5 text-[12.5px] font-medium text-amber-950">
      <Eye className="h-3.5 w-3.5 shrink-0" />
      <span>
        Vendo como <b>{nome}</b> — só leitura · termina às {ate}
      </span>
      <button
        type="button"
        disabled={encerrar.isPending}
        onClick={() => encerrar.mutate()}
        className="inline-flex items-center gap-1 rounded-md bg-amber-950 px-2.5 py-0.5 text-xs font-semibold text-white hover:bg-amber-900 disabled:opacity-60"
      >
        {encerrar.isPending && <Loader2 className="h-3 w-3 animate-spin" />}
        Encerrar
      </button>
    </div>
  );
}
